import { action as apiAction } from 'api/Api'

type Payload = {
  id: number
  contextTag: string
}

export default (payload: Payload) => async () => {
  const { id, contextTag } = payload

  await apiAction('AddBookmark', {
    activityId: id,
    contextTag
  })
}
